import "./index.less";
import template from "./index.html";
import veslLogo from "../../../images/vesl_logo.svg";

function controller(
) {
	const ctrl = this;
	ctrl.veslLogo = veslLogo;

	ctrl.$onInit = () => {
	};
}

export default angular
	.module("vesl.screens.public.oauth-splash", [])
	.component("oauthSplash", {
		template,
		controller
	}).name;
